import axios from 'axios';
import api_url from '../urls';
const actions = {

   async addAvisos (context, dados) {
     
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await   axios.post(api_url.api_admin + 'v1/admin/add-avisos',
         dados,
         {
            headers: {
                'Authorization': AuthStr,
                'Accept' : 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
            .then(response => {
            console.log(response);
            })
            .catch((error) => {
              alert('Error')
           console.log(error.response);
             }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        
    }, 

    async allAvisosDisciplina (context, value) {
     // console.log(value)
      context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await  axios.get(api_url.api_admin + 'v1/admin/all_avisos_disciplina/' + value,
        {
            headers: {
                'authorization': AuthStr,
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        })  
      .then(response => {
          // console.log(response.data);
          context.commit('ALL_AVISOS_DISCIPLINA', response.data)
      })
      .catch((error) => {
          console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
      
  },
  async addChamado (context, dados) {
    context.commit('PRELOADER_MUDAR',true)
    const USER_TOKEN = localStorage.getItem('access_token');
    const AuthStr = 'Bearer '.concat(USER_TOKEN)
  await   axios.post(api_url.api_admin + 'v1/admin/add-chamado',
     dados,
     {
        headers: {
            'Authorization': AuthStr,
            'Accept' : 'application/json',
            'X-Requested-With':'XMLHttpRequest',
        }
    })
        .then(response => {
        //console.log(response);
        })
        .catch((error) => {
          alert('Error')
      // console.log(error.response);
         }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    
}, 
async AllChamadosAlunodisciplina (context, value) {
   // console.log(value)

   context.commit('PRELOADER_MUDAR',true)
     const USER_TOKEN = localStorage.getItem('access_token');
     const AuthStr = 'Bearer '.concat(USER_TOKEN)
   await  axios.get(api_url.api_admin + 'v1/admin/all_chamados_aluno_disciplina/' + value.oferta_data_disciplina_id + '/'+ value.id,
     {
         headers: {
             'authorization': AuthStr,
             'Accept' : 'application/json',
             'Content-Type': 'application/json'
         }
     })  
   .then(response => {
       console.log(response);
       context.commit('ALL_CHAMADOS_ALUNOS', response.data)
   })
   .catch((error) => {
       console.log(error);
     }).finally(()=> context.commit('PRELOADER_MUDAR',false))
   
},

async allRespostasChamado (context, value) {  
  // console.log(value)

  context.commit('PRELOADER_MUDAR',true)
    const USER_TOKEN = localStorage.getItem('access_token');
    const AuthStr = 'Bearer '.concat(USER_TOKEN)
  await  axios.get(api_url.api_admin + 'v1/admin/all_respostas_chamados/' + value.id,
    {
        headers: {
            'authorization': AuthStr,
            'Accept' : 'application/json',
            'Content-Type': 'application/json'
        }
    })  
  .then(response => {
      console.log(response);
      context.commit('ALL_RESPOSTAS_CHAMADOS', response.data)
      context.commit('SET_CHAMADO', value)
  })
  .catch((error) => {
      console.log(error);
    }).finally(()=> context.commit('PRELOADER_MUDAR',false))
  
},

async addResposta (context, dados) {
  console.log(dados)
  context.commit('PRELOADER_MUDAR',true)
  const USER_TOKEN = localStorage.getItem('access_token');
  const AuthStr = 'Bearer '.concat(USER_TOKEN)
await   axios.post(api_url.api_admin + 'v1/admin/add-resposta',
   dados,
   {
      headers: {
          'Authorization': AuthStr,
          'Accept' : 'application/json',
          'X-Requested-With':'XMLHttpRequest',
      }
  })
      .then(response => {
      
      })
      .catch((error) => {
        alert('Error')
    // console.log(error.response);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
  
}, 

async allChamadosAlunosDisciplina (context, value) {
  // console.log(value)

  context.commit('PRELOADER_MUDAR',true)
    const USER_TOKEN = localStorage.getItem('access_token');
    const AuthStr = 'Bearer '.concat(USER_TOKEN)
  await  axios.get(api_url.api_admin + 'v1/admin/all_chamados_alunos_disciplina/' + value.oferta_data_disciplina_id,
    {
        headers: {
            'authorization': AuthStr,
            'Accept' : 'application/json',
            'Content-Type': 'application/json'
        }
    })  
  .then(response => {
      console.log(response);
      context.commit('ALL_CHAMADOS_ALUNOS_DISCIPLINA', response.data)
  })
  .catch((error) => {
      console.log(error);
    }).finally(()=> context.commit('PRELOADER_MUDAR',false))
  
},
async allRespostasChamadoDisciplina (context, value) {
  //console.log(value)
  context.commit('PRELOADER_MUDAR',true)
  const USER_TOKEN = localStorage.getItem('access_token');
  const AuthStr = 'Bearer '.concat(USER_TOKEN)
  await  axios.get(api_url.api_admin + 'v1/admin/all_respostas_chamados_aluno_disciplina/' + value.id,
  {
      headers: {
          'authorization': AuthStr,
          'Accept' : 'application/json',
          'Content-Type': 'application/json'
      }
  })  
  .then(response => {
    console.log(response);
    context.commit('ALL_RESPOSTAS_CHAMADOS_DISCIPLINA', response.data)
    context.commit('SET_CHAMADO', value)
  })
  .catch((error) => {
    console.log(error);
  }).finally(()=> context.commit('PRELOADER_MUDAR',false))
    
    
  },

  async allCalendariaAcademico (context, value) {
    // console.log(value)
     context.commit('PRELOADER_MUDAR',true)
       const USER_TOKEN = localStorage.getItem('access_token');
       const AuthStr = 'Bearer '.concat(USER_TOKEN)
     await  axios.get(api_url.api_admin + 'v1/admin/all_calendario_disciplina/' + value,
       {
           headers: {
               'authorization': AuthStr,
               'Accept' : 'application/json',
               'Content-Type': 'application/json'
           }
       })  
     .then(response => {
         // console.log(response.data);
         context.commit('ALL_CALENDARIO_DISCIPLINA', response.data)
     })
     .catch((error) => {
         console.log(error);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
     
 },
 async addCalenarioMateria (context, dados) {
  console.log(dados)
  context.commit('PRELOADER_MUDAR',true)
  const USER_TOKEN = localStorage.getItem('access_token');
  const AuthStr = 'Bearer '.concat(USER_TOKEN)
await   axios.post(api_url.api_admin + 'v1/admin/addCalendarioMateria',
   dados,
   {
      headers: {
          'Authorization': AuthStr,
          'Accept' : 'application/json',
          'X-Requested-With':'XMLHttpRequest',
      }
  })
      .then(response => {
      
      })
      .catch((error) => {
        alert('Error')
    // console.log(error.response);
       }).finally(()=> context.commit('PRELOADER_MUDAR',false))
  
}, 
  
}

export default actions